import { SyberryTodayWorkItemState, type SyberryTodayTaskId, type SyberryTodayWorkItem } from './types';

export const getUniqueExistingTaskIds = (
  tasksOrExistingTaskIds: SyberryTodayWorkItem[] | Set<SyberryTodayTaskId>,
  taskIds: SyberryTodayTaskId[],
): SyberryTodayTaskId[] => {
  const existingTaskIds =
    tasksOrExistingTaskIds instanceof Set
      ? tasksOrExistingTaskIds
      : new Set(tasksOrExistingTaskIds.map(task => task.id));
  const uniqueTaskIds: SyberryTodayTaskId[] = [];
  const uniqueTaskIdSet = new Set<SyberryTodayTaskId>();

  taskIds.forEach(taskId => {
    if (!existingTaskIds.has(taskId) || uniqueTaskIdSet.has(taskId)) return;

    uniqueTaskIds.push(taskId);
    uniqueTaskIdSet.add(taskId);
  });

  return uniqueTaskIds;
};

export const getSelectedTaskIdsFromTasks = (tasks: SyberryTodayWorkItem[]): SyberryTodayTaskId[] =>
  tasks
    .filter(task => task.selectedForToday)
    .sort((firstTask, secondTask) => (firstTask.todayOrder ?? 0) - (secondTask.todayOrder ?? 0))
    .map(task => task.id);

export const applySelectedTaskIdsToTasks = (
  tasks: SyberryTodayWorkItem[],
  taskIds: SyberryTodayTaskId[],
): SyberryTodayWorkItem[] => {
  const selectedTaskIds = getUniqueExistingTaskIds(tasks, taskIds);
  const selectedTaskIdSet = new Set(selectedTaskIds);
  const selectedTaskOrderById = new Map(selectedTaskIds.map((taskId, index) => [taskId, index + 1]));

  return tasks.map(task => {
    const selectedForToday = selectedTaskIdSet.has(task.id);
    const state = selectedForToday ? SyberryTodayWorkItemState.DO_TODAY : SyberryTodayWorkItemState.QUEUE;
    const todayOrder = selectedForToday ? selectedTaskOrderById.get(task.id) : undefined;

    if (task.selectedForToday === selectedForToday && task.state === state && task.todayOrder === todayOrder) {
      return task;
    }

    return {
      ...task,
      selectedForToday,
      state,
      todayOrder,
    };
  });
};
